module.exports = __webpack_public_path__ + "img/data_moun_jn.63197b48.png";